
// Ready translated locale messages
import Store from '@/store'

export const addTranslations = async (locale, translations) => {
  try {
    let obj = {}
    for (let i in translations) {
      if (translations[i] && translations[i].length > 0) {
        obj[i] = translations[i]
      }
    }
    messages[locale] = {
      ...messages[locale],
      ...obj
    }
    Store.dispatch('context/setI18nMessages', messages[locale])
  } catch (err) {
    console.error('Failed to process translation keys')
  }
}

const spanish = {
  loading: 'Cargando...',
  your_information: 'Donde informationes',
  skip: 'Skipado',
  continue: 'Continioados',
  remember_me: 'Rememberados mio'
}

const english = {
  nationalId: 'National Id',
  nationalId_placeholder: 'National Id (ÅÅMMDDXXXX)',
  email: 'Email',
  email_placeholder: 'Email',
  phonenumber: 'Phone',
  phonenumber_placeholder: 'Phone',
  firstName: 'First name',
  firstName_placeholder: 'First name',
  lastName: 'Last name',
  lastName_placeholder: 'Last name',
  address1: 'Address',
  address1_placeholder: 'Address',
  address2: 'Address',
  address2_placeholder: 'Address',
  zip: 'Zip',
  zip_placeholder: 'Zip',
  city: 'City',
  city_placeholder: 'City',
  username: 'Användarnamn',
  username_placeholder: 'Användarnamn',
  password: 'Lösenord',
  password_placeholder: 'Lösenord',
  manual: 'Register manually',
  loading: 'Loading...',
  sign_bankId_on_your_device: 'Sign in the BankId app to continue',
  your_information: 'Your information',
  shipping_details: 'Shipping details',
  same_shipping_address: 'Use same shipping address',
  other_shipping_address: 'Other shipping address?',
  delete_shipping_address: 'Delete',
  terms_and_conditions: 'Data protection info',
  new_user: 'New user',
  not_you: 'Not you?',
  skip: 'Skip',
  back: 'Back',
  cancel: 'Cancel',
  settings: 'Settings',
  settings_main_text: 'Hi{name}! We will automatically fill our your information for you.',
  settings_sub_text: 'You can turn that off, so that {host} will not store your device and your login credentials. This means that you can not use automatic population of information in order to pay more quickly.',
  save: 'Save',
  continue: 'Continue',
  edit: 'Edit',
  remember_me_on_this_device: 'Remember me on this device',
  remember_me_on_this_device_info: 'How do we store your data?',
  remember_me_settings: 'Privacy settings',
  remember_me_subtext: 'I want {host} to remember this device in the future for automatic prefilling of information.',
  store_my_data: 'Store my data for purchases in the future',
  store_my_data_subtext: 'I want {host} to store my login credentials in a safe matter in order to allow automatic prefilling of information.',
  phonenumber_must_be_10_digits: 'Phonenumber must be 10 digits',
  phonenumber_must_be_8_or_12_digits: 'Phonenumber must be 8 or 12 digits',
  must_be_a_valid_nationalid: 'Nationalid must be valid (YYMMDDXXXX)',
  must_be_a_valid_email_address: 'The address must be valid',
  invalid_default_message: '{name} is required',
  failed_to_get_user_info: 'Failed to get user information',
  failed_to_check_device: 'Failed to check device status',
  failed_to_find_existing_user: 'Failed to get user existing information',
  failed_did_authentication: 'Failed to authenticate',
  continue_with: 'Continue with {provider}',
  missing_did_access_token: 'Failed to save, could not find DID access token',
  login_with_proivider_and_fetch_info: 'Login with {provider} and fetch your credentials automatically',
  login_and_fetch_info: 'Login and fetch your credentials automatically',
  or_register_here_manually: 'Or register manually here',
  user_device_exists_info_1: 'Looks like you have been here before. ',
  user_device_exists_info_2: 'Enter your {identifyField} to continue',
  zip_must_be_4_digits: 'Zip must be 4 digits'
}

const swedish = {
  nationalId: 'Personnummer',
  nationalId_placeholder: 'Personnummer (ÅÅMMDDXXXX)',
  email: 'Epost',
  email_placeholder: 'Epost',
  phonenumber: 'Telefonnummer',
  phonenumber_placeholder: 'Telefonnummer',
  firstName: 'Förnamn',
  firstName_placeholder: 'Förnamn',
  lastName: 'Efternamn',
  lastName_placeholder: 'Efternamn',
  address1: 'Adress',
  address1_placeholder: 'Address',
  address2: 'Adressrad 2',
  address2_placeholder: 'Adressrad 2',
  zip: 'Postkod',
  zip_placeholder: 'Postkod',
  city: 'Ort',
  city_placeholder: 'Ort',
  username: 'Username',
  username_placeholder: 'Username',
  password: 'Password',
  password_placeholder: 'Password',
  manual: 'Registrera manuellt',
  loading: 'Laddar...',
  sign_bankId_on_your_device: 'Signera i BankId-appen för att fortsätta',
  your_information: 'Dina uppgifter',
  shipping_details: 'Leverans',
  same_shipping_address: 'Samma leveransadress',
  other_shipping_address: 'Annan leveransadress?',
  delete_shipping_address: 'Ta bort',
  terms_and_conditions: 'Datasekretess info',
  new_user: 'Ny användare',
  not_you: 'Inte du?',
  skip: 'Hoppa över',
  back: 'Tillbaka',
  cancel: 'Avbryt',
  settings: 'Inställningar',
  settings_main_text: 'Hej{name}! Det här fyller vi automatiskt åt dig.',
  settings_sub_text: 'Du kan stänga av att {host} lagrar din enhet och dina inloggningsuppgifter. Det innebär att du inte kan använda automatisk ifyllning för att betala snabbare.',
  save: 'Spara',
  continue: 'Fortsätt',
  edit: 'Ändra',
  remember_me_on_this_device: 'Kom ihåg mig på den här enheten',
  remember_me_on_this_device_info: 'Vad gör vi med dina data?',
  remember_me_settings: 'Sekretessinställningar',
  remember_me_subtext: 'Jag vill att {host} kommer ihåg min nuvarande enhet för automatisk ifyllning.',
  store_my_data: 'Lagra min data för framtida köp',
  store_my_data_subtext: 'Jag vill att {host} lagrar mina inloggningsuppgifter på ett säkert sätt för automatisk ifyllning.',
  phonenumber_must_be_10_digits: 'Telefonnummret måste vara 10 siffor',
  phonenumber_must_be_8_or_12_digits: 'Telefonnummret måste vara 8 eller 12 siffror',
  must_be_a_valid_nationalid: 'Måste vara ett giltigt personnummer (YYMMDDXXXX)',
  must_be_a_valid_email_address: 'Måste vara en giltig adress',
  invalid_default_message: '{name} är obligatoriskt',
  failed_to_get_user_info: 'Hittade ingen användarinfo',
  failed_to_check_device: 'Kunde inte hitta enhet',
  failed_to_find_existing_user: 'Hittade inte existerande användarinfo',
  failed_did_authentication: 'Misslyckades med autentisering',
  continue_with: 'Fortsätt med {provider}',
  missing_did_access_token: 'Kunde inte spara, DID access token saknas',
  login_with_proivider_and_fetch_info: 'Logga in med {provider} hämta dina uppgifter automatiskt',
  login_and_fetch_info: 'Logga in och hämta dina uppgifter automatiskt',
  or_register_here_manually: 'Eller registrera dig manuellt här',
  user_device_exists_info_1: 'Du verkar ha varit här förut. ',
  user_device_exists_info_2: 'Skriv in din {identifyField} för att fortsätta',
  zip_must_be_4_digits: 'Postnummret måste vara 4 siffor'
}

const danish = {
  loading: 'Ladder...',
  your_information: 'Din information',
  skip: 'Hoppa œver',
  continue: 'Fortsætt',
  manual: 'Manuelt register',
  email: 'Epost',
  email_placeholder: 'Epost',
  phonenumber: 'Telefonnummer',
  phonenumber_placeholder: 'Telefonnummer',
  firstName: 'Fornavn',
  firstName_placeholder: 'Fornavn',
  lastName: 'Efternavn',
  lastName_placeholder: 'Efternavn',
  address1: 'Adresse',
  address1_placeholder: 'Adresse',
  address2: 'Adresse 2',
  address2_placeholder: 'Adresse 2',
  zip: 'Zip',
  zip_placeholder: 'Zip',
  city: 'By',
  city_placeholder: 'By',
  shipping_details: 'Levering',
  same_shipping_address: 'Samme leveringsadresse',
  other_shipping_address: 'Alternativ leveransadress?',
  delete_shipping_address: 'Fjerne',
  terms_and_conditions: 'Data for beskyttelse af personlige oplysninger',
  new_user: 'Ny bruger',
  back: 'Tilbage',
  cancel: 'Afbestille',
  settings: 'Indstillinger',
  settings_main_text: 'Hej {name} Vi udfylder dette automatisk for dig.',
  settings_sub_text: 'Du kan slå {host} lagring af din enhed og dine loginoplysninger fra. Dette betyder, at du ikke kan bruge automatisk påfyldning for at betale hurtigere.',
  save: 'Gemme',
  edit: 'Redigere',
  remember_me_on_this_device: 'Husk mig',
  remember_me_settings: 'Privatindstillinger',
  remember_me_subtext: 'Jag vill att {host} kommer i øjeblikket min nuværende enhed for automatisk ifyllning.',
  store_my_data: 'Gem mine data til fremtidige køb',
  store_my_data_subtext: 'Jeg vil have, at {host} skal gemme mine loginoplysninger sikkert til automatisk færdiggørelse.',
  phonenumber_must_be_10_digits: 'Telefonnummeret skal være 10 cifre',
  phonenumber_must_be_8_or_12_digits: 'Telefonnummeret skal være 8 eller 12 cifre',
  must_be_a_valid_email_address: 'Skal være en gyldig adresse',
  invalid_default_message: '{name} er obligatorisk',
  failed_to_get_user_info: 'Kunne ikke få brugeroplysninger',
  failed_to_check_device: 'Kunne ikke kontrollere enhedens status',
  failed_to_find_existing_user: 'Kunne ikke hente brugerens eksisterende information',
  failed_did_authentication: 'Kunne ikke godkende',
  continue_with: 'Fortsæt med {provider}',
  missing_did_access_token: 'Kunne ikke gemme, manglende DID-adgangstoken',
  login_with_proivider_and_fetch_info: 'Log ind med {provider} for automatisk at hente dine oplysninger',
  login_and_fetch_info: 'Log ind for automatisk at hente dine oplysninger',
  or_register_here_manually: 'Eller registrer manuelt her',
  user_device_exists_info_1: 'Du ser ud til at have været her før. ',
  user_device_exists_info_2: 'Indtast {identifyField} for at fortsætte'
}
const finnish = {
  loading: 'Ladataan...',
  your_information: 'Sinun tietosi',
  skip: 'Ohita',
  continue: 'Jatkaa',
  manual: 'Manuaalinen rekisteröinti',
  email: 'Sähköposti',
  email_placeholder: 'Sähköposti',
  phonenumber: 'Puhelinnumero',
  phonenumber_placeholder: 'Puhelinnumero',
  firstName: 'Etunimi',
  firstName_placeholder: 'Etunimi',
  lastName: 'Sukunimi',
  lastName_placeholder: 'Sukunimi',
  address1: 'Osoite',
  address1_placeholder: 'Osoite',
  address2: 'Osoite 2',
  address2_placeholder: 'Osoite 2',
  zip: 'Zip',
  zip_placeholder: 'Zip',
  city: 'Kaupunki',
  city_placeholder: 'Kaupunki',
  shipping_details: 'Rahti tiedot',
  same_shipping_address: 'Sama toimitusosoite',
  other_shipping_address: 'Muu toimitusosoite?',
  delete_shipping_address: 'Poista toimitusosoite',
  terms_and_conditions: 'Käyttöehdot',
  new_user: 'Uusi käyttäjä',
  back: 'Takaisin',
  settings: 'Asetukset',
  settings_main_text: 'Hei {name} Täytämme tämän automaattisesti sinulle.',
  settings_sub_text: 'Voit sammuttaa laitteesi {host} -tallennuksen ja kirjautumistietosi. Tämä tarkoittaa, että et voi käyttää automaattista täyttämistä maksaaksesi nopeammin.',
  save: 'Tallentaa',
  edit: 'Muokata',
  remember_me_on_this_device: 'Muista minut',
  remember_me_settings: 'Tietosuoja-asetukset',
  remember_me_subtext: 'Haluan, että {host} saa nykyisen automaattisen täyttölaitteeni tällä hetkellä.',
  store_my_data: 'Tallenna tietoni tulevia ostoja varten',
  store_my_data_subtext: 'Haluan, että {host} tallentaa kirjautumistietoni turvallisesti automaattista täydentämistä varten.',
  phonenumber_must_be_10_digits: 'Puhelinnumeron on oltava 10 numeroa',
  must_be_a_valid_email_address: 'Täytyy olla kelvollinen osoite',
  invalid_default_message: '{name} vaaditaan',
  failed_to_get_user_info: 'Käyttäjätietojen nouto epäonnistui',
  failed_to_check_device: 'Laitteen tilan tarkistaminen epäonnistui',
  failed_to_find_existing_user: 'Käyttäjän olemassa olevien tietojen nouto epäonnistui',
  failed_did_authentication: 'Todennus epäonnistui',
  continue_with: 'Jatka {provider}',
  missing_did_access_token: 'Tallennus ei onnistunut, puuttui DID-käyttöoikeustunnus',
  login_with_proivider_and_fetch_info: 'Kirjaudu sisään {provider} saadaksesi tietosi automaattisesti',
  login_and_fetch_info: 'Kirjaudu saadaksesi tietosi automaattisesti',
  or_register_here_manually: 'Tai rekisteröidä manuaalisesti täällä',
  user_device_exists_info_1: 'Näytät olleen täällä aiemmin. ',
  user_device_exists_info_2: 'Anna {identifyField} jatkaa'
}

const german = {
  loading: 'Ladder...',
  your_information: 'Ihre Informationen',
  skip: 'Überspringen',
  continue: 'Fortsetzen',
  remember_me: 'Behalte mich in Erinnerung'
}

const french = {
  loading: 'Chargement...',
  your_information: 'Vos informations',
  skip: 'Sauter',
  continue: 'Continuer',
  remember_me: 'Souviens-toi de moi'
}

// ALL OF THE TRANSLATION PROPERTIES NEEDS TO BE HERE FIRST FOR VUE TO 'LISTEN' TO THE UPDATES
export const messages = {
  no_NO: {
    loading: 'Laster...',
    your_information: 'Din informasjon',
    skip: 'Skip',
    continue: 'Fortsett',
    cancel: 'Avbryt',
    failed_to_get_user_info: 'Kunne ikke få brukerinformasjon',
    failed_to_check_device: 'Kunne ikke sjekke enhetsstatusen',
    failed_to_find_existing_user: 'Kunne ikke hente brukerens eksisterende informasjon',
    failed_did_authentication: 'Kunne ikke autentisere',
    continue_with: 'Fortsett med {provider}',
    nationalId: 'Personlig',
    nationalId_placeholder: 'Personlig',
    email: 'E-post',
    email_placeholder: 'E-post',
    phonenumber: 'Telefonnummer',
    phonenumber_placeholder: 'Telefonnummer',
    firstName: 'Fornavn',
    firstName_placeholder: 'Fornavn',
    lastName: 'Etternavn',
    lastName_placeholder: 'Etternavn',
    address1: 'Adresse',
    address1_placeholder: 'Adresse',
    address2: 'Adresse 2',
    address2_placeholder: 'Adresse 2',
    zip: 'Post kode',
    zip_placeholder: 'Post kode',
    city: 'By',
    city_placeholder: 'By',
    username: 'Brukernavn',
    username_placeholder: 'Brukernavn',
    password: 'Passord',
    password_placeholder: 'Passord',
    manual: 'Registrer manuelt',
    shipping_details: 'Leveranse',
    same_shipping_address: 'Samme leveringsadresse',
    other_shipping_address: 'Alternativ leveringsadresse?',
    delete_shipping_address: 'Ta vekk',
    terms_and_conditions: 'Informasjon om personvern',
    new_user: 'Ny bruker',
    not_you: 'Ikke deg?',
    back: 'Tillbake',
    settings: 'Innstillinger',
    settings_main_text: 'Hei {name} Vi fyller dette automatisk for deg.',
    settings_sub_text: 'Du kan slå av {host} og lagre enheten din og legitimasjonen. Dette betyr at du ikke kan bruke automatisk fylling for å betale raskere.',
    save: 'Lagre',
    edit: 'Redigere',
    remember_me_on_this_device: 'Husk meg',
    remember_me_on_this_device_info: 'Hvordan lagrer vi dataene dine?',
    remember_me_settings: 'Personverninnstillinger',
    remember_me_subtext: 'Jeg vil at {host} skal huske min nåværende automatiske utfyllingsenhet.',
    store_my_data: 'Lagre dataene mine for fremtidige kjøp',
    store_my_data_subtext: 'Jeg vil at {host} skal lagre påloggingsinformasjonen min sikkert for automatisk fullføring.',
    phonenumber_must_be_10_digits: 'Telefonnummeret må være på 10 sifre',
    phonenumber_must_be_8_or_12_digits: 'Telefonnummeret må være på 8 eller 12 sifre',
    must_be_a_valid_email_address: 'Må være en gyldig adresse',
    invalid_default_message: '{name} er obligatorisk',
    missing_did_access_token: 'Kunne ikke lagre, manglende DID-tilgangstoken',
    login_with_proivider_and_fetch_info: 'Logg på med {provider} for å hente informasjonen din automatisk',
    login_and_fetch_info: 'Logg på for å hente informasjonen din automatisk',
    or_register_here_manually: 'Eller registrer deg manuelt her',
    user_device_exists_info_1: 'Du ser ut til å ha vært her før. ',
    user_device_exists_info_2: 'Skriv inn {identifyField} for å fortsette',
    zip_must_be_4_digits: 'Postnummeret må bestå av 4 sifre'

  },
  en: { ...english },
  en_GB: { ...english },
  en_US: { ...english },
  sv_SE: { ...swedish },
  sv_SE_tablet: { ...swedish },
  sv_SE_mobile: { ...swedish },
  es: {
    ...spanish
  },
  es_CO: {
    ...spanish
  },
  dk: { ...danish },
  da_DK: { ...danish },
  fi_FI: {
    ...finnish
  },
  de: { ...german },
  de_DE: { ...german },
  fr_FR: { ...french }
}

for (let i in messages) {
  messages[i]['all_transactions'] = 'All transactions'
}
